import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

export const useHomePage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, signInWithGoogle, signOut } =
    useAuthStore();

  const handleLogin = () =>
    signInWithGoogle().catch((e) =>
      window.alert(`ログインに失敗しました: ${e}`),
    );

  const handleStartGame = () => {
    navigate('/game');
  };

  const handleLogout = async () => {
    try {
      await signOut();
    } catch (e) {
      window.alert(`ログアウトに失敗しました: ${e}`);
    }
  };

  return {
    isLoading,
    isAuthenticated,
    handleLogin,
    handleStartGame,
    handleLogout,
  };
};
